import styled from "styled-components";

const Button = styled.button`
  border-radius: 8px;
  border: none;
  padding-left: 24px;
  padding-right: 24px;
  min-height: 48px;
  background: var(--commonRed);
  color: white;
  cursor: pointer;
  position: relative;
  transition: transform .3s;
  font-size: 15px;
  :hover::before {
    position: absolute;
    content: "";
    background: rgba(255, 255, 255, 0.1);
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  :active {
    transform: scale(0.98);
  }

  @media(max-width: 480px) {
    height: 42px;
    font-weight: 500;
    width: 100%;
  }
`;

export default Button;